import { Box } from "@mui/material";
import { useIsMobile } from "../../hooks/useIsMobile";
import { size } from "../../designTokens/other";

export const PageContainer = ({ children, expand = false, sx }) => {
  const isMobile = useIsMobile("xl");

  // expand 모드일 때는 더 넓은 컨테이너 사용
  const containerWidth = expand
    ? isMobile
      ? "100%"
      : "min(1400px, 90vw)"
    : isMobile
    ? "100%"
    : size.lg;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: containerWidth,
        minHeight: "calc(100vh - 62px)",
        padding: isMobile ? "16px 16px 0 16px" : "24px 0 0 0",
        margin: "0 auto", // 중앙 정렬
		...sx,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "80px",
          paddingTop: isMobile ? "24px" : "32px",
          paddingBottom: "64px",
          overflowX: "hidden",
          width: "100%",
        }}
      >
        {children}
      </Box>
    </Box>
  );
};
